import axiosInstance from "../../../helpers/api";

export const listAllMainStudentExams = (search = null) => {
  const params = search ? { search } : {};
  return axiosInstance.get("/admin/student_exams/main_exam", { params });
};

export const redoExam = (studentExamId) => {
  return axiosInstance.post("/admin/student_exams/redo_exam", {
    student_exam_id: studentExamId,
  });
};

export const getStudentExamFile = (filename) => {
  const safeName = encodeURIComponent(String(filename || "").replace(/^\//, ""));
  return axiosInstance.get(`/admin/student_exams/file/${safeName}`, {
    responseType: "arraybuffer",
  });
};

